import "./vertical-scroll-menu.scss";

import React from "react";

const VerticalScrollMenu = ({ tabs }) => {
  return (
    <div className="vertical-menu">
      {tabs?.map((tab, index) => {
        return (
          <a
            key={index}
            href={`#${tab.anchor}`}
            className="vertical-menu__item"
          >
            {tab.label}
          </a>
        );
      })}
    </div>
  );
};

export default VerticalScrollMenu;
